import { createFileRoute } from '@tanstack/react-router'
import { Teams } from '@/features/staff/teams'
import { requireActiveSubscription } from '@/lib/middleware'

export const Route = createFileRoute(
  '/_authenticated/_organization/staff/teams/'
)({
  beforeLoad: async () => requireActiveSubscription(),
  component: Teams,
})
